<template>
    <div class="UpVideo">
        <div class="add-wrap" v-if="videoFile == ''">
            <div class="defaultImg">
                <p>点击此处上传图片或视频</p>
                <p class="tips">支持扩展名：.jpg .png .mp4</p>
                <p class="tips">视频上限100MB</p>
            </div>
            <input
                type="file"
                class="file"
                @change="addChangeVideo"
                ref="inputImg"
                accept="video/mp4, image/gif, image/jpeg, image/png, image/jpg"
            />
        </div>
        <div class="video" v-if="videoFile">
            <video :src="videoFile" controls="controls" v-if="fileType == 2"></video>
            <img :src="videoFile" v-if="fileType == 1" />
            <input
                type="file"
                class="file"
                @change="addChangeVideo"
                ref="inputImg"
                accept="video/mp4, image/gif, image/jpeg, image/png, image/jpg"
            />
        </div>
        <i class="el-icon-circle-close" @click="cancel"></i>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'single-video',
        props: {
            file: {
                type: String
            }
        },
        data() {
            return {
                fileType: 1,
                isUpload: false, // 正在上传
                videoName: '',
                defaultImg: this.$Public.defaultImg,
                videoFile: this.file,
                progress: 0
            };
        },
        created() {},
        methods: {
            addChangeVideo(e) {
                // 上传视频
                this.upFile(e, res => {
                    this.videoFile = res;
                    this.$emit('getFile', res, this.fileType);
                    this.$refs.inputImg.value = '';
                });
            },
            upFile(e, fun) {
                // 上传文件
                this.progress = 0;
                let file = e.target.files[0];
                let fileSize = file.size;
                this.videoName = e.target.files[0].name;
                if (!file) {
                    return;
                }
                if (fileSize > 104857600) {
                    this.$message.error('视频大小超过限制,上限100MB!');
                    return;
                }
                if (file.type == 'video/mp4') {
                    this.fileType = 2;
                } else {
                    this.fileType = 1;
                }
                console.log('fileSize', fileSize);

                this.httpUploadImg({ type: this.fileType, file: file }).then(
                    res => {
                        fun(res);
                    },
                    res => {}
                );
            },
            cancel() {
                this.videoFile = '';
                this.$emit('getFile', '', this.fileType);
            }
        },
        watch: {
            file(val) {
                this.videoFile = val;
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    i {
        position: absolute;
        right: -10px;
        top: 0;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.45);
    }

    .el-icon-upload2 {
        color: blue;
    }

    .inline-left {
        margin-top: 30px;

        .icon {
            width: 16px;
            height: 16px;
            fill: gary9;
            margin-right: 10px;
        }
    }

    .UpVideo {
        flex-x(flex-start, flex-start);
        position: relative;

        .add-wrap {
            position: relative;
            width: 120px;
            height: 120px;
            background: grayF6;
            border: 1px dashed gray9;
            margin-top: 10px;

            .defaultImg {
                width: 120px;
                height: 120px;

                .add {
                    font-size: 30px;
                    color: rgba(0, 0, 0, 0.45);
                }

                flex-y(center, center);

                p {
                    text-align: center;
                }
            }
        }

        .edit-wrap {
            position: relative;

            img {
                width: 100%;
                height: 100%;
            }
        }

        input {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    .video {
        width: 120px;
        height: 120px;
        margin-top: 10px;

        video {
            width: 120px;
            height: 120px;
        }

        img {
            width: 120px;
            height: 120px;
        }
    }

    p {
        float: left;
    }
</style>
